/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type:  * `standard` - A tenant for standard customers  * `partner` -  A tenant of a partner that manages it\'s own clients  * `managed` - A tenant managed by another tenant i.e. partner.  * `admin` - Internal admin account  * `internal` - Internal dev account  * `trial` - External test users  * `development` - Develop dev account  * `test` - A tenant for testing  * `reseller` - Reseller tenat  * `distributor` - Distributor tenant 
 */
export enum TenantTypeEnumDTO {
    STANDARD = 'standard',
    PARTNER = 'partner',
    MANAGED = 'managed',
    ADMIN = 'admin',
    INTERNAL = 'internal',
    TRIAL = 'trial',
    DEVELOPMENT = 'development',
    TEST = 'test',
    RESELLER = 'reseller',
    DISTRIBUTOR = 'distributor'
}

export class ClsTenantTypeEnumDTO {
    STANDARD = 'standard';
    PARTNER = 'partner';
    MANAGED = 'managed';
    ADMIN = 'admin';
    INTERNAL = 'internal';
    TRIAL = 'trial';
    DEVELOPMENT = 'development';
    TEST = 'test';
    RESELLER = 'reseller';
    DISTRIBUTOR = 'distributor';
}

